import React, { forwardRef } from "react";
import { InputNumber, Select, Input } from "antd";
import { CreditCard } from "lucide-react";

interface CardPaymentOptionProps {
  cardAmount: number;
  setCardAmount: (amount: number) => void;
  cardBankAccountId: string;
  setCardBankAccountId: (id: string) => void;
  cardTxNo: string;
  setCardTxNo: (txNo: string) => void;
  bankAccounts: any[];
  paymentMode: string;
  note?: string;
  setNote?: (note: string) => void;
}

export const CardPaymentOption = forwardRef<any, CardPaymentOptionProps>(
  (
    {
      cardAmount,
      setCardAmount,
      cardBankAccountId,
      setCardBankAccountId,
      cardTxNo,
      setCardTxNo,
      bankAccounts,
      paymentMode,
      note,
      setNote,
    },
    ref,
  ) => {
    return (
      <div className="border border-gray-150 rounded-xl p-3 bg-white hover:border-indigo-300 transition-all flex flex-col gap-2">
        <div className="flex justify-between items-center">
          <span className="text-xs font-semibold text-gray-700 flex items-center gap-1.5">
            <CreditCard className="w-4 h-4 text-indigo-500" /> Card Payment
          </span>
          {cardAmount > 0 && (
            <span className="text-[10px] bg-indigo-50 text-indigo-600 font-bold px-1.5 py-0.5 rounded-full">
              Active
            </span>
          )}
        </div>
        <div className="grid grid-cols-2 gap-2">
          <div className="flex flex-col gap-1 col-span-2">
            <label className="text-[9px] font-semibold text-gray-400 uppercase tracking-wider">
              Amount
            </label>
            <InputNumber
              ref={ref}
              value={cardAmount}
              onChange={(v) => setCardAmount(v || 0)}
              min={0}
              className="w-full border-gray-200"
              formatter={(v) =>
                `LKR ${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(v) => v!.replace(/LKR\s?|(,*)/g, "") as any}
            />
          </div>
          {(cardAmount > 0 || paymentMode === "card") && (
            <>
              <div className="flex flex-col gap-1 col-span-2">
                <label className="text-[9px] font-semibold text-gray-400 uppercase tracking-wider">
                  Deposit Bank Account *
                </label>
                <Select
                  value={cardBankAccountId || undefined}
                  onChange={setCardBankAccountId}
                  placeholder="Select Bank..."
                  className="w-full border-gray-200"
                  options={bankAccounts.map((ba: any) => ({
                    value: ba.id,
                    label: `${ba.bank_name} - ${ba.account_number} (${ba.account_name})`,
                  }))}
                />
              </div>
              <div className="flex flex-col gap-1 col-span-2">
                <label className="text-[9px] font-semibold text-gray-400 uppercase tracking-wider">
                  Card Tx Ref Number (Optional)
                </label>
                <Input
                  value={cardTxNo}
                  onChange={(e) => setCardTxNo(e.target.value)}
                  placeholder="TX-XXXX"
                  className="border-gray-200"
                />
              </div>
            </>
          )}
          {setNote && (
            <div className="flex flex-col gap-1 col-span-2 mt-1">
              <label className="text-[9px] font-semibold text-gray-400 uppercase tracking-wider">
                Payment Notes (Optional)
              </label>
              <Input.TextArea
                value={note || ""}
                onChange={(e) => setNote(e.target.value)}
                placeholder="Add payment notes here..."
                rows={2}
                style={{ resize: "none" }}
                className="border-gray-200"
              />
            </div>
          )}
        </div>
      </div>
    );
  },
);
